<template>
  <client-only>
    <div class="divider" :style="`width:${width} ; background:${color} ; height:${height}`" />
  </client-only>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: '90%',
      required: false
    },
    color: {
      type: String,
      default: '#f6f7f9',
      required: false
    },
    height: {
      type: String,
      default: '5px',
      required: false
    }
  }
}
</script>

<style scoped>
.divider {
  margin: auto;
}
</style>
